<script lang="ts" setup>
import { sm } from "~/utils/breakpoints"
</script>

<template>
  <div class="grid-standard mb-6 overflow-hidden">
    <SkeletonBreadcrumbs />

    <SkeletonAnimatedPlaceholder
      height="232px"
      width="200%"
      class="negative-margined col-span-full mb-6"
    />

    <div class="col-span-full overflow-hidden md:col-span-5 md:col-start-2">
      <SkeletonAnimatedPlaceholder
        height="35px"
        width="100%"
        borderRadius="4px"
        class="mb-6"
      />

      <!-- Paragraph -->
      <div
        v-for="(paragraph, index) in 5"
        :key="`paragraph-${index}`"
        class="mb-8"
      >
        <!-- Title -->
        <SkeletonAnimatedPlaceholder
          height="25px"
          width="250px"
          borderRadius="4px"
          class="mb-3"
        />

        <!-- Text -->
        <SkeletonAnimatedPlaceholder
          v-for="(text, index) in 4"
          :key="`text-${index}`"
          height="15px"
          :width="index === 3 ? '150px' : '100%'"
          borderRadius="4px"
          class="mb-1"
        />
      </div>
    </div>

    <SkeletonAnimatedPlaceholder
      :height="sm ? '500px' : '100%'"
      width="100%"
      borderRadius="4px"
      class="col-span-full md:col-span-4 md:col-start-8 md:mt-[59px]"
    />
  </div>
</template>
